<template>
  <div id="tournamentCard">
    <v-card>
      <div class="tag-container">
        <span class="white--text pa-1 pl-3 pr-2" :class="tagTournament">{{
          messageTournament
        }}</span>
      </div>
      <div class="img-container" style="height: 150px;">
        <v-img
          :src="image"
          @error="alternative"
          style="max-height: 100%; max-width: 100%;"
          ref="imageCard"
        >
        </v-img>
      </div>
      <v-card-title primary-title>
        <div>
          <div class="headline">{{ tournament.name }}</div>
          <div class="grey--text">
            {{
              tournament.description
                ? tournament.description.substring(0, 100)
                : ''
            }}
            <span
              v-if="
                tournament.description && tournament.description.length > 100
              "
              >...</span
            >
          </div>
        </div>
      </v-card-title>
      <v-card-actions>
        <v-btn
          v-if="can('edit', 'team')"
          @click="openInscription()"
          color="secondary"
          :disabled="!isInscripcion"
          small
          v-show="this.tournament.openInscription"
          :loading="loadingInscription"
          >{{ $t('inscription') }}</v-btn
        >
        <v-btn
          color="success"
          small
          @click="openAcceder()"
          :loading="loading"
          >{{ $t('access') }}</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn @click="view = !view" icon>
          <v-icon>{{
            view ? 'keyboard_arrow_down' : 'keyboard_arrow_up'
          }}</v-icon>
        </v-btn>
      </v-card-actions>
      <v-slide-y-transition>
        <v-card-text v-show="view">
          <b>{{ $t('startAt') }}:</b>
          {{ dateFormat(tournament.startAt) }}
          <br />
          <b>{{ $t('endAt') }}:</b>
          {{ dateFormat(tournament.endAt) }}
          <br />
          <div v-for="stadium in listStadiumsRelated" :key="stadium._id">
            <b>{{ $t('location') }}:</b>
            <v-icon>location_on</v-icon>
            {{ stadium.name }}
            <a
              :href="
                `https://www.google.es/maps/dir/${stadiumAddress(
                  stadium._id
                )}/home/@${stadium.lat},${stadium.long}`
              "
              target="_blank"
              v-if="routeLogic(stadium)"
              >Como llegar</a
            >
            <br />
          </div>
        </v-card-text>
      </v-slide-y-transition>
    </v-card>
    <dialog-map
      :modal="dialogRoute"
      :stadium="sendStadium"
      @close="closeRoute()"
      :name="tournament.name"
    />
  </div>
</template>

<script>
import { dateFormat } from '../../../helpers/dateHelper'
import { mapActions, mapState } from 'vuex'
import moment from 'moment'
import DialogMap from './DialogMapRoute'

export default {
  name: 'TournamentCard',
  components: {
    DialogMap
  },
  props: {
    tournament: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      view: false,
      modal: false,
      loading: false,
      loadingInscription: false,
      dialogRoute: false,
      sendStadium: null,
      errorImg: false
    }
  },
  computed: {
    ...mapState({
      stadiums: state => state.stadiums.listStadiums
    }),
    isBefore() {
      if (!moment(this.tournament.endAt).isValid()) return false
      let endAt = moment(this.tournament.endAt).endOf('day')
      if (this.tournament.endAt.includes('T'))
        endAt = moment(this.tournament.endAt.split('T')[0]).endOf('day')

      return moment()
        .startOf('day')
        .isBefore(endAt)
    },
    image() {
      if (process.env.VUE_APP_IMAGE_URL) {
        if (this.errorImg) {
          return process.env.VUE_APP_IMAGE_URL + 'default-tournament.png'
        } else return process.env.VUE_APP_IMAGE_URL + this.tournament.img
      }
      return ''
    },
    isInscripcion() {
      if (!this.isBefore) {
        return false
      }
      return (
        this.countTeams(this.tournament.teams) <
        this.tournament.numberParticipants
      )
    },
    tagTournament() {
      if (!this.isBefore) {
        return 'tag-end'
      }
      if (!this.tournament.openInscription) {
        return 'tag-completed'
      }
      if (!this.tournament.numberParticipants) {
        return 'tag-inscription'
      }
      const countTeams = this.countTeams(this.tournament.teams)
      if (countTeams < this.tournament.numberParticipants) {
        return 'tag-inscription'
      }
      return 'tag-completed'
    },
    messageTournament() {
      if (!this.isBefore) {
        return this.$t('finished')
      }
      if (!this.tournament.openInscription) {
        return this.$t('complete')
      }
      if (!this.tournament.numberParticipants) {
        return this.$t('openInscription')
      }
      const countTeams = this.countTeams(this.tournament.teams)
      if (countTeams < this.tournament.numberParticipants) {
        return this.$t('openInscription')
      }
      return this.$t('complete')
    },
    listStadiumsRelated() {
      let stadium = []
      this.tournament.stadiumId.forEach(element => {
        let temporalStadium = this.stadiums.find(item => item._id === element)
        if (temporalStadium) {
          stadium.push(temporalStadium)
        }
      })
      return stadium
    }
  },
  methods: {
    ...mapActions({
      setRanking: 'matches/setRanking',
      setResults: 'matches/setResults',
      queryMatches: 'matches/query',
      setInitAds: 'advertising/setInit',
      getOne: 'tournaments/setOne',
      initCourses: 'courses/setInit'
    }),
    routeLogic(stadium) {
      return stadium.lat && stadium.long
    },
    stadiumAddress(id) {
      if (!this.tournament || !this.tournament.stadiumId) {
        return ' '
      }
      let result = this.listStadiumsRelated.find(item => item._id === id)
      if (!result) {
        return ' '
      }
      let address = result.address.replace(/\s/g, '+')
      if (result.cp) {
        address += ', ' + result.cp
      }
      return address
    },
    alternative() {
      this.errorImg = true
    },
    countTeams(teams) {
      if (!teams) {
        return 0
      }
      if (!Array.isArray(teams)) {
        return 1
      }
      let count = teams.filter(item => item && item.confirmed && item.accepted)
      return count.length
    },
    dateFormat(date) {
      return dateFormat(date, false)
    },
    openAcceder() {
      this.loading = true
      this.getOne(this.tournament._id)
        .then(result => {
          this.queryMatches({ tournamentId: this.tournament._id })
          this.setRanking({ tournamentId: this.tournament._id })
          this.setResults(this.tournament._id)
          this.setInitAds({ tournamentId: this.tournament._id })
          this.initCourses({ tournaments: this.tournament._id })
          this.$emit('access')
        })
        .finally(() => {
          this.loading = false
        })
    },
    openInscription() {
      this.loadingInscription = true
      this.getOne(this.tournament._id)
        .then(result => this.$emit('signup'))
        .finally(() => {
          this.loadingInscription = false
        })
    },
    closeRoute() {
      this.dialogRoute = false
    },
    routeTo(stadium) {
      this.sendStadium = stadium
      this.dialogRoute = true
    }
  }
}
</script>
<style lang="scss">
#tournamentCard {
  .tag-container {
    position: absolute;
    display: flex;
    z-index: 100;
    right: 0;
  }
  .img-container {
    height: 150px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .grey--text {
    min-height: 80px;
  }

  .mt-45 {
    margin-top: -45px;
  }

  .mt-56 {
    margin-top: -56px;
  }

  .title-tournament {
    text-shadow: 1px 1px #000;
    color: #62c6c5;
  }

  .tag-inscription {
    background-color: #6273b7;
  }

  .tag-end {
    background-color: red;
  }

  .tag-completed {
    background-color: #ffc107;
  }
}
</style>
